const STORE = {
  CACHE:{},
  profiles:{}
};

export const getStore = ()=> STORE;
// export default STORE;